"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_REGISTRY = exports.SCHEMA_VERSION = void 0;
exports.SCHEMA_VERSION = '1.1.0';
exports.QUESTION_REGISTRY = [
    {
        id: 'orgName',
        section: 'basics',
        label: 'Organization name',
        type: 'string',
        required: true,
    },
    {
        id: 'schoolName',
        section: 'basics',
        label: 'School name',
        type: 'string',
        required: true,
    },
    {
        id: 'state',
        section: 'basics',
        label: 'State',
        type: 'string',
        required: true,
    },
    {
        id: 'duesRequired',
        section: 'members',
        label: 'Require dues?',
        type: 'boolean',
        required: true,
        default: false,
    },
    {
        id: 'duesAmount',
        section: 'members',
        label: 'Dues amount ($)',
        type: 'number',
        required: false,
        visibleIf: (a) => !!a['duesRequired'],
        validate: (v, a) => a['duesRequired'] && (!v || Number(v) <= 0)
            ? 'Enter a positive dues amount'
            : null,
    },
    {
        id: 'membersIncludeParentsGuardians',
        section: 'members',
        label: 'Parents and guardians',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'membersIncludePrincipal',
        section: 'members',
        label: 'Principal',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'membersIncludeStaff',
        section: 'members',
        label: 'Teachers and staff',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerPresident',
        section: 'officers',
        label: 'President',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerVicePresident',
        section: 'officers',
        label: 'Vice-President',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerTreasurer',
        section: 'officers',
        label: 'Treasurer',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerViceTreasurer',
        section: 'officers',
        label: 'Vice-Treasurer',
        type: 'boolean',
        required: false,
        default: false,
    },
    {
        id: 'officerSecretary',
        section: 'officers',
        label: 'Secretary',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerMemberAtLarge',
        section: 'officers',
        label: 'Member-at-Large',
        type: 'boolean',
        required: false,
        default: false,
    },
    {
        id: 'officerCommunications',
        section: 'officers',
        label: 'Communications Coordinator',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'officerVolunteerCoordinator',
        section: 'officers',
        label: 'Volunteer Coordinator',
        type: 'boolean',
        required: false,
        default: true,
    },
    {
        id: 'electionMonth',
        section: 'terms',
        label: 'Election month',
        type: 'month',
        required: true,
    },
    {
        id: 'termLength',
        section: 'terms',
        label: 'Term length (years)',
        type: 'number',
        required: true,
        default: 1,
    },
    {
        id: 'termLimit',
        section: 'terms',
        label: 'Term limit (consecutive terms)',
        type: 'number',
        required: true,
        default: 2,
    },
    {
        id: 'meetingFrequency',
        section: 'meetings',
        label: 'Meeting frequency',
        type: 'string',
        required: true,
        default: 'monthly',
    },
    {
        id: 'quorumExecNumber',
        section: 'meetings',
        label: 'Executive Board quorum (#)',
        type: 'number',
        required: true,
        default: 3,
        visibleIf: (answers) => answers['quorumExecMode'] === 'Specific number',
    },
    {
        id: 'quorumExecMode',
        section: 'meetings',
        label: 'Quorum mode',
        type: 'string',
        required: true,
        default: 'half the number of board members plus one',
    },
    {
        id: 'noticeDays',
        section: 'meetings',
        label: 'Notice required for meetings (days)',
        type: 'number',
        required: true,
        default: 10,
    },
    {
        id: 'fiscalYearStartMonth',
        section: 'finances',
        label: 'Fiscal year start month',
        type: 'month',
        required: true,
        default: 'July',
    },
    {
        id: 'fiscalYearStartDay',
        section: 'finances',
        label: 'Fiscal year start day',
        type: 'day',
        required: true,
        default: 1,
    },
    {
        id: 'fiscalYearEndMonth',
        section: 'finances',
        label: 'Fiscal year end month',
        type: 'month',
        required: true,
        default: 'July',
    },
    {
        id: 'fiscalYearEndDay',
        section: 'finances',
        label: 'Fiscal year end day',
        type: 'day',
        required: true,
        default: 30,
    },
    {
        id: 'routineSpendingLimit',
        section: 'finances',
        label: 'Routine spending limit ($)',
        type: 'number',
        required: true,
        default: 200,
    },
    {
        id: 'nonBudgetedBoardLimit',
        section: 'finances',
        label: 'Non-budgeted board limit ($)',
        type: 'number',
        required: true,
        default: 500,
    },
    {
        id: 'auditMethod',
        section: 'finances',
        label: 'Annual financial review performed by',
        type: 'string',
        required: true,
        default: 'Two members',
    },
    {
        id: 'checkSignersMode',
        section: 'finances',
        label: 'Check signing',
        type: 'string',
        required: true,
        default: 'twoSigners',
        options: [
            {
                value: 'twoSigners',
                label: 'Require 2 signers on each check (recommended)',
            },
            {
                value: 'noRequirement',
                label: '2nd signer optional',
            },
        ],
    },
    {
        id: 'conflictAppliesTo',
        section: 'compliance',
        label: 'Who does your conflict-of-interest policy apply to?',
        type: 'select',
        required: true,
        default: 'Board, officers, and key volunteers',
        options: [
            {
                value: 'Board and officers only',
                label: 'Board and officers only',
            },
            {
                value: 'Board, officers, and key volunteers',
                label: 'Board, officers, and key volunteers',
            },
        ],
    },
    {
        id: 'conflictRecordkeeping',
        section: 'compliance',
        label: 'How much recordkeeping do you want for conflicts?',
        type: 'select',
        required: true,
        default: 'Standard (keep a simple log of disclosures)',
        options: [
            {
                value: 'Minimal (note conflicts in the minutes)',
                label: 'Minimal (note conflicts in the minutes)',
            },
            {
                value: 'Standard (keep a simple log of disclosures)',
                label: 'Standard (keep a simple log of disclosures)',
            },
        ],
    },
    {
        id: 'amendmentVoteThreshold',
        section: 'amendments',
        label: 'Vote required to approve amendments',
        type: 'string',
        required: true,
        default: 'Majority',
    },
    {
        id: 'amendmentNoticeDays',
        section: 'amendments',
        label: 'Amendment notice days',
        type: 'number',
        required: true,
        default: 14,
    },
];
